<template>
    <div class="strategy-list">
        <div class="strategy-opration">

            <div style="display: inline-block;margin-right: 50px">
                <span>交易对:</span>
                <el-select v-model="queryParams.pair" filterable placeholder="请选择交易对">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item,index) in pairOptions"
                               :key="item.exchangeCoin+'_'+item.anchoredCoin+'_'+index"
                               :label="item.exchangeCoin+'/'+item.anchoredCoin"
                               :value="item.exchangeCoin+'_'+item.anchoredCoin">
                    </el-option>
                </el-select>
            </div>

            <div style="display: inline-block;margin-right: 50px">
                <span>状态:</span>
                <el-select v-model="queryParams.isEnable" placeholder="状态">
                    <el-option label="已启用" :value="true"></el-option>
                    <el-option label="未启用" :value="false"></el-option>
                </el-select>
            </div>

            <div style="display: inline-block;margin-right: 50px">
                <span>推荐状态:</span>
                <el-select v-model="queryParams.isRecommend" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已推荐" :value="1"></el-option>
                    <el-option label="未推荐" :value="0"></el-option>
                </el-select>
            </div>

            <el-input placeholder="请输入策略名称" v-model="queryParams.strategyName" prefix-icon="el-icon-search"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="searchSupplier">搜索</el-button>

        </div>
        <div class="strategy-list">
            <el-table class="strategy-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="策略编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="strategyName" label="策略名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="策略简介" show-overflow-tooltip></el-table-column>
                <el-table-column prop="coinType" label="售卖币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="pair" label="交易对" show-overflow-tooltip></el-table-column>
                <el-table-column prop="weight" label="权重" show-overflow-tooltip></el-table-column>
                <el-table-column prop="likeCount" label="关注总数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subCount" label="订阅总数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="limitFreeCount" label="免费订阅次数" show-overflow-tooltip></el-table-column>

                <el-table-column label="连续包月(原价/现价)" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.alwaysMonthOriginPrice +"/"+ scope.row.alwaysMonthCurrentPrice}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="订阅一个月(原价/现价)" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.oneMonthOriginPrice +"/"+ scope.row.oneMonthCurrentPrice}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="订阅三个月(原价/现价)" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.threeMonthOriginPrice +"/"+ scope.row.threeMonthCurrentPrice}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="推荐" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.isRecommend | formatRecommend}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="停用/启用时间" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateDate | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="限时免费开始时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.limitFreeBegin | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="限时免费结束时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.limitFreeEnd | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否启用" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-switch :value="scope.row.isEnable" active-color="#13ce66" :disabled="true"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="550px">
                    <template slot-scope="scope">
                        <el-button type="primary" v-if="scope.row.isEnable==false" @click="startUse(scope.row)">启用
                        </el-button>
                        <el-button type="danger" v-if="scope.row.isEnable==true" @click="stopUse(scope.row)">停用
                        </el-button>
                        <el-button type="primary" @click="strategyEditorDialog(scope.row)">策略编辑</el-button>
                        <el-button type="primary" v-if="scope.row.isRecommend==0" @click="setRecommend(scope.row)">
                            设置推荐
                        </el-button>
                        <el-button type="danger" v-if="scope.row.isRecommend==1" @click="cancleRecommend(scope.row)">
                            取消推荐
                        </el-button>
                        <el-button type="primary" @click="historySignals(scope.row)" style="margin-top: 10px">历史信号
                        </el-button>
                        <el-button type="primary" @click="paidEditorDialog(scope.row)" style="margin-top: 10px">付费编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="付费编辑" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <el-form label-width="180px" :model="dataSupplier" :rules="dataRules" ref="dataForm">
                <div style="font-weight: bold;margin-bottom: 20px">1、连续包月</div>
                <el-form-item label="售卖价（BKK）：" prop="alwaysMonthOriginPrice">
                    <el-input v-model="dataSupplier.alwaysMonthCurrentPrice" placeholder="请输入订阅售卖价"></el-input>
                </el-form-item>
                <el-form-item label="划线价（BKK）：" prop="alwaysMonthCurrentPrice">
                    <el-input v-model="dataSupplier.alwaysMonthOriginPrice" placeholder="请输入订阅划线价"></el-input>
                </el-form-item>

                <div style="font-weight: bold;margin-bottom: 20px">2、单独购买1月</div>
                <el-form-item label="售卖价（BKK）：" prop="oneMonthOriginPrice">
                    <el-input v-model="dataSupplier.oneMonthCurrentPrice" placeholder="请输入订阅售卖价"></el-input>
                </el-form-item>
                <el-form-item label="划线价（BKK）：" prop="oneMonthCurrentPrice">
                    <el-input v-model="dataSupplier.oneMonthOriginPrice" placeholder="请输入订阅划线价"></el-input>
                </el-form-item>
                <el-form-item label="是否支持免费订阅：" prop="onFree">
                    <el-switch v-model="dataSupplier.onFreeBoolen" @change="onFreeChange"
                               active-color="#13ce66"></el-switch>
                </el-form-item>
                <el-form-item label="限时免费：" prop="dateArr">
                    <el-date-picker :disabled="!dataSupplier.onFreeBoolen"
                                    v-model="dataSupplier.dateArr"
                                    type="datetimerange"
                                    value-format="timestamp"
                                    range-separator="至"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="单个用户免费购买次数：" prop="limitFreeCount">
                    <el-input v-model="dataSupplier.limitFreeCount" :disabled="!dataSupplier.onFreeBoolen"
                              placeholder="请输入购买次数"></el-input>
                </el-form-item>

                <div style="font-weight: bold;margin-bottom: 20px">3、单独购买3月</div>
                <el-form-item label="售卖价（BKK）：" prop="threeMonthOriginPrice">
                    <el-input v-model="dataSupplier.threeMonthCurrentPrice" placeholder="请输入订阅售卖价"></el-input>
                </el-form-item>
                <el-form-item label="划线价（BKK）：" prop="threeMonthCurrentPrice">
                    <el-input v-model="dataSupplier.threeMonthOriginPrice" placeholder="请输入订阅划线价"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible=false">取 消</el-button>
                <el-button type="danger" @click="paidEditor">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="策略编辑" :visible.sync="strategyDialogVisible" width="40%" @close="clearData">
            <el-form label-width="120px" :model="dataStrategy" :rules="dataStrategyRules" ref="dataStrategyForm">
                <el-form-item label="交易对：" prop="pair">
                    <el-input v-model="dataStrategy.pair" placeholder="请输入交易对"></el-input>
                </el-form-item>
                <el-form-item label="策略简介：" prop="content">
                    <div v-for="lang in languages" :key="lang.value" class="introduction-editor">
                        <div class="introduction-editor-header">{{ lang.label }}策略简介</div>
                        <el-input :value="contentJson[lang.value]" type="textarea"
                                  :rows="3" @change="handleContentJsonChange(lang.value, $event)"></el-input>
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="strategyDialogVisible=false">取 消</el-button>
                <el-button type="danger" @click="strategyEditor">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import LANGUAGES from "../../../common/languages_code";

    export default {
        name: "AllTask",
        data() {
            return {
                dataList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    isRecommend: "",
                    strategyName: "",
                    pair: "",
                    isEnable: false,
                    providerMerchant: "",
                    page: 1,
                    size: 10
                },
                pairOptions: [], //交易对弹框
                dialogVisible: false,
                dataSupplier: {
                    strategyId: "",
                    alwaysMonthOriginPrice: "",
                    alwaysMonthCurrentPrice: "",
                    oneMonthOriginPrice: "",
                    oneMonthCurrentPrice: "",
                    threeMonthOriginPrice: "",
                    threeMonthCurrentPrice: "",
                    onFree: 0,
                    onFreeBoolen: false,
                    limitFreeBegin: "",
                    limitFreeEnd: "",
                    limitFreeCount: "",
                    dateArr: []
                },
                dataRules: {
                    "alwaysMonthOriginPrice": [{required: true, message: "请输入订阅售卖价"}],
                    "alwaysMonthCurrentPrice": [{required: true, message: "请输入订阅划线价"}],
                    "oneMonthOriginPrice": [{required: true, message: "请输入订阅售卖价"}],
                    "oneMonthCurrentPrice": [{required: true, message: "请输入订阅划线价"}],
                    "threeMonthOriginPrice": [{required: true, message: "请输入订阅售卖价"}],
                    "threeMonthCurrentPrice": [{required: true, message: "请输入订阅划线价"}],
                    "onFree": [{required: true, message: "请选择是否支持免费订阅"}],
                    "limitFreeBegin": [{required: true, message: "请选择限时免费开始时间"}],
                    "limitFreeEnd": [{required: true, message: "请选择限时免费结束时间"}],
                    "limitFreeCount": [{required: true, message: "请输入购买次数"}],
                    "dateArr": [{required: true, message: "请选择限时免费时间"}],
                },
                strategyDialogVisible: false,
                dataStrategy: {
                    strategyId: "",
                    pair: "",
                    content: ""
                },
                dataStrategyRules: {
                    "pair": [{required: true, message: "请输入交易对"}],
                    "content": [{required: true, message: "请输入策略简介"}]
                },
                contentJson: {},
                languages: Object.keys(LANGUAGES).map(lang => ({
                    label: LANGUAGES[lang],
                    value: lang
                }))
            }
        },
        computed: {},
        mounted() {
        },
        filters: {
            formatRecommend(state) {
                switch (state) {
                    case 1:
                        return "是";
                    case 0:
                        return "否";
                }
            }
        },
        methods: {
            initData() {
                Object.keys(LANGUAGES).map(lang => {
                    this.contentJson[lang] = "";
                })
            },
            handleContentJsonChange(lang, value) {
                this.contentJson[lang] = value;
                this.dataStrategy.content = JSON.stringify(this.contentJson);
            },
            onFreeChange() {
                this.dataSupplier.onFree = this.dataSupplier.onFreeBoolen ? 1 : 0;
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getSupplierList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getSupplierList(this.queryParams);
            },
            getSupplierList(param) {
                api.getInfoPage(param).then(({data}) => {
                    this.dataList = data.data;
                    this.total = data.total;
                });
            },
            searchSupplier() {
                this.queryParams.page = 1;
                this.getSupplierList(this.queryParams);
            },
            getPair() {
                api.getAllSupportingPairs().then(({data}) => {
                    this.pairOptions = data;
                });
            },
            historySignals(row) {
                this.$router.push({
                    path: '/home/strategy/supplier/historySignals',
                    query: {
                        id: row.id
                    }
                });
            },
            stopUse(row) {
                this.$confirm('是否确认停用策略 ' + row.strategyName + ' ！', '停用策略', {
                    type: 'warning'
                }).then(() => {
                    api.updateInfoConf({strategyId: row.id, isEnable: false}).then(({data}) => {
                        this.getSupplierList(this.queryParams);
                        this.$message.success('停用成功！');
                    });
                }).catch(() => {
                });
            },
            startUse(row) {
                this.$confirm('是否确认启用策略 ' + row.strategyName + ' ！', '启用策略', {
                    type: 'warning'
                }).then(() => {
                    api.updateInfoConf({strategyId: row.id, isEnable: true}).then(({data}) => {
                        this.getSupplierList(this.queryParams);
                        this.$message.success('启用成功！');
                    });
                }).catch(() => {
                });
            },
            setRecommend(row) {
                this.$prompt('是否进行推荐设置 ' + row.strategyName + ' ！', '设置推荐', {
                    inputPlaceholder: '请输入优先级',
                    inputValue: ''
                }).then(({value}) => {
                    api.updateInfoConf({strategyId: row.id, isRecommend: 1, weight: value}).then(({data}) => {
                        this.getSupplierList(this.queryParams);
                        this.$message.success('取消成功！');
                    });
                });
            },
            cancleRecommend(row) {
                this.$confirm('是否取消策略的推荐设置 ' + row.strategyName + ' ！', '取消推荐', {
                    type: 'warning'
                }).then(() => {
                    api.updateInfoConf({strategyId: row.id, isRecommend: 0}).then(({data}) => {
                        this.getSupplierList(this.queryParams);
                        this.$message.success('取消成功！');
                    });
                }).catch(() => {
                });
            },
            paidEditor() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.dataSupplier.limitFreeBegin = this.dataSupplier.dateArr[0];
                        this.dataSupplier.limitFreeEnd = this.dataSupplier.dateArr[1];
                        api.updateInfoConf(this.dataSupplier).then(({data}) => {
                            this.dialogVisible = false;
                            this.getSupplierList(this.queryParams);
                            this.$message.success('保存成功！');
                        });
                    }
                });
            },
            strategyEditor(row) {
                this.$refs["dataStrategyForm"].validate(valid => {
                    if (valid) {
                        api.updateInfoConf(this.dataStrategy).then(({data}) => {
                            this.strategyDialogVisible = false;
                            this.getSupplierList(this.queryParams);
                            this.$message.success('保存成功！');
                        });
                    }
                });
            },
            strategyEditorDialog(row) {
                this.dataStrategy = {
                    strategyId: row.id,
                    pair: row.pair,
                    content: row.content
                }
                this.contentJson = row.content ? JSON.parse(row.content) : {};
                this.strategyDialogVisible = true;
            },
            paidEditorDialog(row) {
                this.dataSupplier = {
                    strategyId: row.id,
                    alwaysMonthOriginPrice: row.alwaysMonthOriginPrice,
                    alwaysMonthCurrentPrice: row.alwaysMonthCurrentPrice,
                    oneMonthOriginPrice: row.oneMonthOriginPrice,
                    oneMonthCurrentPrice: row.oneMonthCurrentPrice,
                    threeMonthOriginPrice: row.threeMonthOriginPrice,
                    threeMonthCurrentPrice: row.threeMonthCurrentPrice,
                    onFree: row.onFree,
                    onFreeBoolen: row.onFree == 1 ? true : false,
                    limitFreeBegin: row.limitFreeBegin,
                    limitFreeEnd: row.limitFreeEnd,
                    limitFreeCount: row.limitFreeCount,
                    dateArr: [row.limitFreeBegin, row.limitFreeEnd]
                }
                this.dialogVisible = true;
            },
            clearData() {
                this.dataSupplier = {
                    strategyId: "",
                    alwaysMonthOriginPrice: "",
                    alwaysMonthCurrentPrice: "",
                    oneMonthOriginPrice: "",
                    oneMonthCurrentPrice: "",
                    threeMonthOriginPrice: "",
                    threeMonthCurrentPrice: "",
                    onFree: false,
                    onFreeBoolen: false,
                    limitFreeBegin: "",
                    limitFreeEnd: "",
                    limitFreeCount: "",
                    dateArr: []
                }
                this.dataStrategy = {
                    strategyId: "",
                    pair: "",
                    content: ""
                }
                this.contentJson={};
                this.initData();
            }
        },
        created() {
            this.getPair();
            this.getSupplierList(this.queryParams);
        }
    }
</script>


<style type="text/css">
    .strategy-list .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: rgba(245, 249, 255, 0);
        z-index: 1;
    }
</style>
<style lang="less" scoped>
    .strategy-list {

        .strategy-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .strategy-table {
                margin-top: 30px;

                .red {
                    color: #EC6D56;
                }
                .blue {
                    color: #406CE9;
                }
                .green {
                    color: #6dec82;
                }
            }
        }
    }
</style>